import React from "react";
import { TRoadblockDayViewListItem } from "../../../../../../domain/codecs/form/RoadblockDayViewForm";
import { TRoadblockAwaitableEntity } from "../../../../../../domain/codecs/form/RoadblockForm";
import { TPlainUser } from "../../../../../../domain/codecs/User";
import { CRMColors } from "../../../../models/CRMColors";
import { CRMFontSizes } from "../../../../models/CRMFontSizes";
import { CRMSpacing } from "../../../../models/CRMSpacing";
import { Background } from "../../../BuildingBlocks/Background";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { Text } from "../../../BuildingBlocks/Text";
import { CRMIcon } from "../../../CRMIcon/CRMIcon";
import { CRMDayRoadblockRow } from "../CRMDayRoadblockRow/CRMDayRoadblockRow";

type TCRMDayParkedBandProps = {
    parkedRoadblocks: Array<TRoadblockDayViewListItem>;
    assignableUsers: Array<TPlainUser>;
    awaitableEntities: Array<TRoadblockAwaitableEntity>;
    isDayClear: boolean;
    onChangeAssignee: (payload: { roadblock_id: string, assigned_to_user_id: string }) => void;
    onAwait: (payload: { roadblock_id: string, awaitable_entities_id: string, days_override: number | null }) => void;
    onCancelAwait: (payload: { roadblock_id: string }) => void;
};

export const CRMDayParkedBand = (props: TCRMDayParkedBandProps): JSX.Element => {
    const [isManuallyOpen, setIsManuallyOpen] = React.useState<boolean>(false);
    const isOpen = props.isDayClear || isManuallyOpen;

    if (props.parkedRoadblocks.length === 0) {
        return <></>;
    }

    return (
        <div className="crm-day-parked-band">
            <div
                className="crm-day-parked-band__header"
                onClick={() => setIsManuallyOpen(!isManuallyOpen)}
            >
                <Background
                    color={CRMColors.NEUTRAL_12}
                    padding={`${CRMSpacing.TINY} ${CRMSpacing.MEDIUM}`}
                >
                    <SpacingRow spacing={CRMSpacing.TINY} childSize="auto 1fr">
                        <CRMIcon
                            iconName={isOpen ? "up-arrow" : "down-arrow"}
                            size="tiny"
                            colour="neutral-0"
                        />
                        <Text
                            size={CRMFontSizes.X_SMALL}
                            weight={700}
                            letterSpacing="0.7px"
                            color={CRMColors.NEUTRAL_2}
                        >
                            {`PARKED BY US · ${props.parkedRoadblocks.length}`}
                        </Text>
                    </SpacingRow>
                </Background>
            </div>

            {isOpen &&
                <SpacingColumn>
                    {props.parkedRoadblocks.map((roadblock) => (
                        <CRMDayRoadblockRow
                            key={roadblock.id}
                            roadblock={roadblock}
                            assignableUsers={props.assignableUsers}
                            awaitableEntities={props.awaitableEntities}
                            isDateShown={true}
                            isCaseContinuation={false}
                            onChangeAssignee={props.onChangeAssignee}
                            onAwait={props.onAwait}
                            onCancelAwait={props.onCancelAwait}
                        />
                    ))}
                </SpacingColumn>
            }
        </div>
    );
};
